/**
 * Reflection voice pairing.
 *
 * Umbra reads reflections back in a DIFFERENT voice than the one the user
 * chose for prompts — so the "Mirror" feels like another presence responding.
 *
 * Given the user's preferred prompt voice, return a complementary voice.
 * Falls back to a safe pair if the input is missing/unknown.
 */
const PAIR = {
  fable: "onyx",      // storytelling → grounded
  nova: "sage",       // bright → measured
  shimmer: "onyx",    // softly cheerful → grounded
  onyx: "fable",      // deep → warm storyteller
  alloy: "sage",
  echo: "coral",
  sage: "nova",
  coral: "echo",
  // legacy aliases (in case older accounts still store these)
  sarah: "onyx",
  aria: "sage",
  charlotte: "onyx",
  daniel: "fable",
};

export const getReflectionVoice = (promptVoice) => {
  const key = (promptVoice || "").toLowerCase();
  return PAIR[key] || "onyx";
};

/**
 * Human-friendly label for the paired reflection voice.
 */
const LABELS = {
  fable: "Fable",
  nova: "Nova",
  shimmer: "Shimmer",
  onyx: "Onyx",
  alloy: "Alloy",
  echo: "Echo",
  sage: "Sage",
  coral: "Coral",
};

export const getVoiceLabel = (voiceId) => LABELS[(voiceId || "").toLowerCase()] || "Onyx";
